.HomeContent {
  background-color: var(--overlay);
  height: 100%;
  border-radius: 30px;
  overflow-y: auto;
  padding: 24px;
}

.Title {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  text-align: center;
  width: 100%;
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.Desc {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: var(--colori-neutri-gray);
  margin-top: 16px;
  text-align: center;
}

.CardPaese {
  border-radius: 10px;
  background: var(--Colori-Neutri-background, #fbfbfb);

  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  width: 100%;
  padding: 8px;
  
  margin-bottom: 8px;
  cursor: pointer;
}

.CardPaeseTitle {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--primary);
  display: flex;
  align-items: center;
}

.LabelInfo {
  color: var(--colori-neutri-gray);
  text-align: center;
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.ValueInfo {
  color: var(--primary);
  text-align: center;
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 4px;
}
